import { render } from "./SetPrice.vue?vue&type=template&id=103a2ae8"
import script from "./SetPrice.vue?vue&type=script&lang=js"
export * from "./SetPrice.vue?vue&type=script&lang=js"

import "./SetPrice.vue?vue&type=style&index=0&id=103a2ae8&lang=css"
script.render = render

export default script